import { Container } from '@/components'
import {
  BrandedForms,
  SmartForms,
  Responsive,
  Usage,
  Banner,
  Brand,
  Integrations,
  OpenSourceCTA,
  Cta,
  Testimonials
} from '@/components/home'
import { HomePageService } from '@/service'

const Home = ({ githubStars, userCount, creators, testimonials }): JSX.Element => (
  <Container customHeader={<></>}>
    <Banner
      githubStars={githubStars}
      userCount={userCount}
      creators={creators}
    />
    <Brand />
    <BrandedForms />
    <SmartForms />
    <Responsive />
    <Usage />
    <Integrations />
    <OpenSourceCTA githubStars={githubStars} />
    <Testimonials testimonials={testimonials} />
    <Cta />
  </Container>
)

export async function getServerSideProps(): Promise<unknown> {
  const [githubStars, userCount, creators, testimonials] = await Promise.all([
    HomePageService.githubStars(),
    HomePageService.userCount(),
    HomePageService.creators(),
    HomePageService.testimonials()
  ])

  return {
    props: {
      githubStars,
      userCount,
      creators,
      testimonials
    }
  }
}

export const config = {
  runtime: 'experimental-edge'
}

export default Home
